import React, { useEffect, useState } from "react";
import Button from "../../common/ui/Button";
import PasswordInput from "../../common/ui/Inputs/PasswordInput";
import changePasswordSchema from "../../../validation/changePasswordSchema";
import { encryptData, decryptData } from "../../../utils/encryptDecrypt";
import { changePasswordActions } from "./../../../_store/changePassword.slice";
import { useDispatch, useSelector } from "react-redux";
import { showToastNotification } from "../../common/ui/NotificationModal/ToastNotication.js";
import { history } from "../../../_helpers";
import { authActions, masterActions } from "../../../_store";
import CustomLoader from "../../common/ui/Loader";
import { StoredProcedures } from "../../../_helpers/enumerator";

function ChangePassword() {
  const user = useSelector((x) => x.auth?.user);
  const { commonFacilityCode } = useSelector((x) => x.auth);
  const { changedpassword, loading } = useSelector((x) => x.changePassword);
  const dispatch = useDispatch();

  const [changePassword, setChangePassword] = useState({
    ManagementUserID: user?.ManagementUserID,
    CurrentPassword: "",
    NewPassword: "",
    confirmPassword: "",
  });

  // Separate showPassword state for each field
  const [showPassword, setShowPassword] = useState({
    CurrentPassword: false,
    NewPassword: false,
    confirmPassword: false,
  });
  // response in changepassword
  useEffect(() => {
    switch (changedpassword?.IsSucceed) {
      case 1:
        showToastNotification("password updated successfully", "success");
        // Insert Management User Activity Log
        dispatch(authActions?.ManagementUserActivityLog({
          ManagementUserID: user?.ManagementUserID,
          facilityID: commonFacilityCode,
          ProcedureName: StoredProcedures?.MangementUserPWDUpdate,
          UserAction: `Password Changed`,
        }));
        // history.navigate("/facilityuser");
        dispatch(changePasswordActions?.clearpassword());
        dispatch(authActions?.logout());
        dispatch(authActions?.removeCommonFaciityCode());
        break;

      case -1:
        showToastNotification(
          "Something went wrong. Please try again",
          "error"
        );
        dispatch(changePasswordActions.clearpassword());
        setChangePassword({
          ManagementUserID: "",
          CurrentPassword: "",
          NewPassword: "",
          confirmPassword: "",
        });
        setShowPassword({
          CurrentPassword: false,
          NewPassword: false,
          confirmPassword: false,
        });
        break;

      case -2:
        showToastNotification("Password cannot be empty", "error");
        dispatch(changePasswordActions.clearpassword());
        setChangePassword({
          ManagementUserID: "",
          CurrentPassword: "",
          NewPassword: "",
          confirmPassword: "",
        });
        setShowPassword({
          CurrentPassword: false,
          NewPassword: false,
          confirmPassword: false,
        });
        break;
      case -3:
        showToastNotification("User ID does not exist", "error");
        dispatch(changePasswordActions.clearpassword());
        setChangePassword({
          ManagementUserID: "",
          CurrentPassword: "",
          NewPassword: "",
          confirmPassword: "",
        });
        setShowPassword({
          CurrentPassword: false,
          NewPassword: false,
          confirmPassword: false,
        });
        break;
      case -4:
        showToastNotification(
          "Current password is invalid. Please try again.",
          "error"
        );
        dispatch(changePasswordActions.clearpassword());
        setChangePassword({
          ManagementUserID: "",
          CurrentPassword: "",
          NewPassword: "",
          confirmPassword: "",
        });
        setShowPassword({
          CurrentPassword: false,
          NewPassword: false,
          confirmPassword: false,
        });
        break;
      case -5:
        showToastNotification(
          "The new password cannot be the same as the old one",
          "error"
        );
        dispatch(changePasswordActions.clearpassword());
        setChangePassword({
          ManagementUserID: "",
          CurrentPassword: "",
          NewPassword: "",
          confirmPassword: "",
        });
        setShowPassword({
          CurrentPassword: false,
          NewPassword: false,
          confirmPassword: false,
        });
        break;
      default:
        break;
    }
  }, [changedpassword]);
  const [errorMessage, setErrorMessage] = useState({});

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e?.target;
    //  const regex = /^[']*$/;  
    //   if (regex.test(value)) return;
      if (value.includes("'")) return;
      if (value.includes("`")) return;
    setChangePassword({ ...changePassword, [name]: value });

  };

  // Validate a New Password field
  const handleBlur = (e) => {
    const { name, value } = e.target;
    validateField(name, value);
  };


  // const validateCurrentPwd = () => {
  //   const userPwd = decryptData(correctpwd); // Ensure decryptData is defined
  //   if (changePassword?.CurrentPassword && changePassword?.CurrentPassword !== userPwd) {
  //     setErrorMessage((prevErrors) => ({
  //       ...prevErrors,
  //       CurrentPassword: "The old password does not match our records",
  //     }));
  //     return false;
  //   }
  //   else {
  //     return true;
  //   }
  // };


  // Validate a single field
  const validateField = (fieldName, value) => {
    // const userPwd = decryptData(correctpwd);
    // if (fieldName == "CurrentPassword" && value !== userPwd && value !== "") {
    //   setErrorMessage((prevErrors) => ({
    //     ...prevErrors,
    //     ["CurrentPassword"]: "The old password does not match our records",
    //   }));
    //   return;
    // }
    const validation = changePasswordSchema({ ...changePassword, [fieldName]: value });

    if (validation?.error) {
      const fieldError = validation?.error?.details?.find((err) => err?.context?.key === fieldName);
      setErrorMessage((prevErrors) => ({
        ...prevErrors,
        [fieldName]: fieldError ? fieldError?.message : "",
      }));
    } else {
      setErrorMessage((prevErrors) => ({
        ...prevErrors,
        [fieldName]: "",
      }));
    }
  };

  // Toggle visibility of individual password fields
  const togglePasswordVisibility = (fieldName) => {
    setShowPassword((prev) => ({
      ...prev,
      [fieldName]: !prev[fieldName],
    }));
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    setErrorMessage({});
    if (document?.getElementsByClassName("input-error").length !== 0) {
      document.querySelector(".input-error").classList.remove("input-error");
    }

    // Call the validation schema
    const { error } = changePasswordSchema(changePassword);

    if (error?.details) {
      error?.details?.map((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [e?.path.toString()]: e?.message,
        }));
        document
          .querySelector(`input[name=${path}]`)
          .classList?.add("input-error");
      });
      // const validate = validateCurrentPwd();
      // if (!validate) return;

      return;
    }
    // const validate = validateCurrentPwd();
    // if (!validate) return;

    ///encrypt the data
    const encryptCurrentPassword = encryptData(changePassword?.CurrentPassword);
    const encryptNewPassword = encryptData(changePassword?.NewPassword);

    let params = {
      ManagementUserID: user?.ManagementUserID,
      CurrentPassword: encryptCurrentPassword,
      NewPassword: encryptNewPassword,
    };
    dispatch(changePasswordActions.ChangePassword(params));
  };

  // Handle form reset
  const handleReset = () => {
    setChangePassword({
      ...ChangePassword,
      CurrentPassword: "",
      NewPassword: "",
      confirmPassword: "",
    });
    setShowPassword({
      CurrentPassword: false,
      NewPassword: false,
      confirmPassword: false,
    });

    // Clear error messages
    setErrorMessage({});

    // Remove input error styling
    const inputErrorElements = document?.querySelectorAll(".input-error");
    inputErrorElements?.forEach((input) => {
      input.classList.remove("input-error");
    });
  };

  if (loading) {
    return <CustomLoader />;
  }
  return (
    <div className="container-fluid px-3">
      <div className="card b-r-all p-4 border border-dark-grey mt-3 mx-auto" style={{ maxWidth: "600px" }}>
        <div className="card-body">
          <h2 className="form_title_uppercase text-color text-center mb-3">CHANGE PASSWORD</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <PasswordInput
                name="CurrentPassword"
                id="CurrentPassword"
                label="Current Password"
                value={changePassword.CurrentPassword}
                handleChange={handleChange}
                handleBlur={handleBlur}
                placeholder="Current Password"
                required={true}
                showPassword={showPassword.CurrentPassword}
                togglePasswordVisibility={() =>
                  togglePasswordVisibility("CurrentPassword")
                }
                errorMessage={errorMessage}
                maxlength={25} // Added maxLength here
              />
            </div>
            <div className="mb-3">
              <PasswordInput
                name="NewPassword"
                id="NewPassword"
                label="New Password"
                value={changePassword.NewPassword}
                handleChange={handleChange}
                handleBlur={handleBlur}
                placeholder="New Password"
                required={true}
                showPassword={showPassword.NewPassword}
                togglePasswordVisibility={() =>
                  togglePasswordVisibility("NewPassword")
                }
                errorMessage={errorMessage}
                maxlength={25} // Added maxLength here
              />
            </div>
            <div className="mb-3">
              <PasswordInput
                name="confirmPassword"
                id="confirmPassword"
                label="Confirm Password"
                value={changePassword.confirmPassword}
                handleChange={handleChange}
                handleBlur={handleBlur}
                placeholder="Confirm Password"
                required={true}
                showPassword={showPassword.confirmPassword}
                togglePasswordVisibility={() =>
                  togglePasswordVisibility("confirmPassword")
                }
                errorMessage={errorMessage}
                maxlength={25} // Added maxLength here
              />
            </div>

            <div className="mt-3 d-flex justify-content-center gap-2 flex-wrap">
              <Button
                className="me-2"
                label="Update"
                type="submit"
                variant="danger"
                icon={"fa-solid fa-pen-to-square"}
                status="success"
                disabled={false}
              />
              <Button
                className="me-2"
                label="Reset"
                type="button"
                icon={"fa-solid fa-rotate-right"}
                variant="secondary"
                status="secondary"
                onClick={handleReset}
                disabled={false}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ChangePassword;
